import {blank} from "../trim.js";

export function preprocessHeadersAndRows({headers, rows}, nextHeader) {
  const [newHeaders, ...newRows] = trimmedColumns(matrixTrimmedCells([headers, ...rows]));
  return {
    headers: fillBlankHeaders(padArrayAtLeastTwo(newHeaders), nextHeader),
    rows: newRows
  };
}

function trimmedColumns(list) {
  return trimmedLastColumn(trimmedFirstColumn(list));
}

function trimmedLastColumn(list) {
  const lastColumn = lastColumnIndex(list);
  if (columnEmpty(list, lastColumn)) {
    return list.map(row => row.slice(0, lastColumn));
  }
  return list;
}

function lastColumnIndex(list) {
  return Math.max(...list.map(row => row.length)) - 1;
}

function trimmedFirstColumn(list) {
  if (columnEmpty(list, 0)) {
    return list.map(row => row.slice(1));
  }
  return list;
}

function columnEmpty(table, columnIndex) {
  return table
    .map(line => !line[columnIndex] || blank(line[columnIndex]))
    .reduce((blank1, acc) => blank1 && acc, true);
}

function matrixTrimmedCells(list) {
  return list.map(row => row.map(cell => cell.trim()));
}

function padArrayAtLeastTwo(array) {
  if (array.length === 0) {
    return ['', ''];
  }
  if (array.length === 1) {
    return [array[0], ''];
  }
  return array;
}

function fillBlankHeaders(headers, nextHeader) {
  return headers.map((header, index) => {
    const provided = nextHeader(header, index);
    if (blank(header)) {
      return provided;
    }
    return header;
  });
}
